import { Shield, Download, Heart } from 'lucide-react';

interface TrustBarProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export function TrustBar({ variant = 'light', className = '' }: TrustBarProps) {
  const items = [
    {
      icon: Shield,
      text: 'Private by default',
      description: 'No public profiles, fully encrypted'
    },
    {
      icon: Download,
      text: 'Export anytime',
      description: 'Your data, always accessible'
    },
    {
      icon: Heart,
      text: 'Not therapy',
      description: 'Coaching for clarity, not crisis support'
    }
  ];

  const isDark = variant === 'dark';

  return (
    <div className={`flex flex-wrap items-center justify-center gap-8 ${className}`}>
      {items.map((item, index) => {
        const Icon = item.icon;
        return (
          <div key={index} className="flex items-center gap-3 group">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              isDark
                ? 'bg-white/10 group-hover:bg-white/20'
                : 'bg-sage-100 group-hover:bg-sage-200'
            } transition-colors`}>
              <Icon className={`h-5 w-5 ${isDark ? 'text-white' : 'text-sage-700'}`} />
            </div>
            <div>
              <div className={`font-medium ${isDark ? 'text-white' : 'text-slate-900'}`}>
                {item.text}
              </div>
              <div className={`text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
                {item.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function TrustBarCompact({ variant = 'light', className = '' }: TrustBarProps) {
  const items = [
    { icon: Shield, text: 'Private by default' },
    { icon: Download, text: 'Export anytime' },
    { icon: Heart, text: 'Not therapy' }
  ];

  const isDark = variant === 'dark';

  return (
    <div className={`flex flex-wrap items-center justify-center gap-6 ${className}`}>
      {items.map((item, index) => {
        const Icon = item.icon;
        return (
          <div key={index} className="flex items-center gap-2">
            <Icon className={`h-4 w-4 ${isDark ? 'text-slate-300' : 'text-slate-600'}`} />
            <span className={`text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
              {item.text}
            </span>
          </div>
        );
      })}
    </div>
  );
}
